import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'branch_terms'

export const requests = {
  terms: async () => {
    return axiosForGigbaseBiz.post<DataResponse>(mergeURL(resource, 'term'))
  },
  privacyPolicy: async () => {
    return axiosForGigbaseBiz.post<DataResponse>(
      mergeURL(resource, 'privacy_policy'),
    )
  },
}
